export function getDocumentItemProps(item) {
  return { file: item }
}
